import google, { mapContainerHeight, mapContainerWidth, registerSingleClickEventTrigger, verify } from "@churchofjesuschrist/maps-google";
import MapsService from "@churchofjesuschrist/maps-service";
import DefaultControls, { MapTypeControlStyle } from "@churchofjesuschrist/maps-google-default-controls";
import { standard } from "@churchofjesuschrist/maps-google-styles";
import { removeUndefined } from "@churchofjesuschrist/maps-utils";
import GoogleMapsConverter from "@churchofjesuschrist/maps-google-converter";
let initialized = false;

//TODO: include church maps service logo, default background color from eden, raw loading spinner
class Map {
  constructor(mapDiv, options = {}) {
    if (!initialized) {
      verify();
      construct();
      initialized = true;
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    let {
      styles = [],
      disableDefaultUI,
      mapTypeControl,
      mapTypeControlOptions,
      zoomControl,
      zoomControlOptions,
      geolocateControl,
      legalControl,
      legalControlOptions,
      ...rest
    } = options;
    let coordinates = MapsService.getIpCoordinates({
      sync: true
    });
    let mapOptions = {
      center: coordinates || {
        lat: 0,
        lng: 0
      },
      zoom: coordinates ? 12 : 2,
      tilt: 0,
      disableDefaultUI: true,
      mapTypeControlOptions: removeUndefined({
        mapTypeIds: mapTypeControlOptions ? mapTypeControlOptions.mapTypeIds : undefined
      }),
      scaleControl: true,
      clickableIcons: false,
      //disable clickable google poi
      styles: [...standard, ...styles],
      ...rest
    };

    // super(mapDiv, mapOptions); doesn't work
    google.maps.Map.call(this, mapDiv, mapOptions);
    this.$controls = new DefaultControls({
      mapTypeControl,
      mapTypeControlOptions,
      zoomControl,
      zoomControlOptions,
      geolocateControl,
      legalControl,
      legalControlOptions,
      map: this
    });
    const forwardEvents = ["geolocate", "geolocate_success", "geolocate_error"];
    forwardEvents.forEach(event => {
      this.$controls.addListener(event, (...args) => {
        google.maps.event.trigger(this, event, ...args);
      });
    });
    registerSingleClickEventTrigger(this);
  }
}
const construct = () => {
  GoogleMapsConverter.register();
  const controlOverrides = ["mapTypeControl", "zoomControl", "geolocateControl", "legalControl", "legalControlOptions"];
  Object.setPrototypeOf(Map.prototype, google.maps.Map.prototype);
  Object.setPrototypeOf(Map, google.maps.Map);
  Object.assign(Map.prototype, (() => {
    return {
      getWidth: function () {
        return mapContainerWidth(this);
      },
      getHeight: function () {
        return mapContainerHeight(this);
      },
      geolocate: function () {
        return this.$controls.geolocate();
      },
      changed: function (key) {
        if (controlOverrides.includes(key)) {
          this.$controls.set(key, this.get(key));
        } else {
          google.maps.Map.prototype.changed.call(this, key);
        }
      }
    };
  })());
};
export default Map;
export { MapTypeControlStyle };